import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ngx-table-control-panel',
  templateUrl: './table-control-panel.component.html',
  styleUrls: ['./table-control-panel.component.scss'],
})
export class TableControlPanelComponent implements OnInit {
  @Input() allowDensityChange = false;
  @Input() public defaultDensity = 'loose';
  @Output() public densityChanged: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  public ngOnInit() {
  }

  public onDensityChanged(density: string) {
    this.densityChanged.emit(density);
  }
}
